import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const steps = [
    '/target-income',
    '/state-pension',
    '/final-salary',
    '/other-income',
    '/other-pensions',
    '/available-pot',
    '/annuity',
    '/drawdown',
    '/whats-next',
    '/explore',
    '/next-steps',
];

export const useSteps = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const currentIndex = steps.indexOf(currentPath);
    const isOnOrBeforeAnnuity = currentIndex <= steps.indexOf('/annuity');
    const isOnOrPastAnnuity = currentIndex >= steps.indexOf('/annuity');
    const isOnOrPastDrawdown = currentIndex >= steps.indexOf('/drawdown');
    const isOnOrPastExplore = currentIndex >= steps.indexOf('/explore');

    return {
        currentStep: currentIndex + 1,
        currentPath,
        totalSteps: steps.length,
        previousPath: steps[currentIndex - 1] || '/',
        nextPath: steps[currentIndex + 1],
        isOnOrPastAnnuity,
        isOnOrPastExplore,
        isOnOrPastDrawdown,
        isOnOrBeforeAnnuity,
    };
};

export const useRedirectOnRefresh = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const refreshed = sessionStorage.getItem('refreshed');

        if (refreshed) {
            navigate('/');
        } else {
            sessionStorage.setItem('refreshed', 'true');
        }

        return () => {
            sessionStorage.removeItem('refreshed');
        };
    }, [navigate]);
};
